import { useBackend } from "../../services";

export const useClearThumbnails = () => {
  const { deleteRequest } = useBackend();
  return async () => deleteRequest("admin/clearThumbnails", {});
};
